import { createSlice, configureStore } from "@reduxjs/toolkit";

//displaystatus is 0,1,2
//const initialstate = { displaystatus: 0, resourceID: 0, favoritearray: [] };
const initialstate = {
  displaystatus: 0,
  resourceID: 0,
  favoritearray: [],
  rearchresults: [],
  categoryId: 0,
  subCategoryId: 0,
  keyword: "",
  searchBy: "topic",
  resourceType: ["any"],
  languages: ["any"],
  communities: ["any"],
  accessibility: ["any"],
  cost: ["any"],
  languages_prev: [],
  accessibility_prev: [],
  cost_prev: [],
  communities_prev: [],
  resourceType_prev: [],
  isMaploaded: false,
  searchparams: "",
  categoryName: "",
  subcategoryName: "",
  isDisplayresult: false,
  isPogress: false,
  place: {},
  etlID: "",
  isFavoriteAdded: false,
  isFavoriteRemoved: false,
  isMaploaded: false,
  totolhotline: 0,
  totolphysical: 0,
  isError: 0,
  errormsg: "",
  isApicallneeded: true,
  isDisplayloder: true,
  activeItem: {},
  zoomLevel: 9,
};
const ramstatesSlice = createSlice({
  name: "ramstates",
  initialState: initialstate,
  reducers: {
    updateZoomLevel(state, action) {
      state.zoomLevel = action.payload;
    },
    updateActiveItem(state, action) {
      state.activeItem = action.payload;
    },
    updateLoaderDisplay(state, action) {
      state.isDisplayloder = action.payload;
    },
    updateApiCall(state, action) {
      state.isApicallneeded = action.payload;
    },
    updateTotolsticky(state, action) {
      state.totolsticky = action.payload;
    },
    updateTotolphysical(state, action) {
      state.totolphysical = action.payload;
    },
    updateTotolhotline(state, action) {
      state.totolhotline = action.payload;
    },
    updateErrormsg(state, action) {
      state.errormsg = action.payload;
    },
    updateErrorstatus(state, action) {
      state.totolhotline = action.payload;
    },
    changestatus(state, action) {
      //console.log(action);
      state.displaystatus = action.payload;
    },
    updatemapload(state, action) {
      //console.log(action);
      state.isMaploaded = action.payload;
    },
    addfavorite(state, action) {
      state.favoritearray = action.payload;
    },
    addSearchresult(state, action) {
      state.rearchresults = action.payload;
    },
    changePogress(state, action) {
      state.isPogress = action.payload;
    },
    toogleSeachresultdisplay(state, action) {
      state.isDisplayresult = action.payload;
    },
    updateSeachBy(state, action) {
      state.searchBy = action.payload;
    },
    updateLocation(state, action) {
      state.place = action.payload;
    },
    updateKeyword(state, action) {
      state.keyword = action.payload;
    },
    updateCategory(state, action) {
      state.categoryId = action.payload;
    },
    updatesubCategory(state, action) {
      state.subCategoryId = action.payload;
    },
    updateCategoryName(state, action) {
      state.categoryName = action.payload;
    },
    updatesubCategoryName(state, action) {
      state.subcategoryName = action.payload;
    },
    updateLanguages(state, action) {
      //state.languages_prev = state.languages;
      state.languages = action.payload;
    },
    updateLanguagesPrev(state, action) {
      //state.languages_prev = state.languages;
      state.languages_prev = action.payload;
    },
    updateCommunities(state, action) {
      state.communities = action.payload;
    },
    updateCommunitiesPrev(state, action) {
      state.communities_prev = action.payload;
    },
    updateAccessibility(state, action) {
      state.accessibility = action.payload;
    },
    updateAccessibilityPrev(state, action) {
      state.accessibility_prev = action.payload;
    },
    updateResourceType(state, action) {
      state.resourceType = action.payload;
    },
    updateResourceTypePrev(state, action) {
      state.resourceType_prev = action.payload;
    },
    updateCost(state, action) {
      state.cost = action.payload;
    },
    updateCostPrev(state, action) {
      state.cost_prev = action.payload;
    },
    updateEtlID(state, action) {
      state.etlID = action.payload;
    },
    faviruteAdded(state, action) {
      state.isFavoriteAdded = action.payload;
    },
    faviruteRemoved(state, action) {
      state.isFavoriteRemoved = action.payload;
    },
  },
});

export const ramactions = ramstatesSlice.actions;

const store = configureStore({
  reducer: ramstatesSlice.reducer,
});

export default store;
